module.exports = __webpack_public_path__ + "img/Premium Focus02.4a4f4323.png";